/** 타로 주제 — 오늘의 운세 + 사람들이 가장 궁금해하는 8가지 */
export const TOPICS = [
  'today',
  'love',
  'friendship',
  'business',
  'study',
  'marriage',
  'luck',
  'money',
  'health',
] as const;
export type Topic = (typeof TOPICS)[number];

export const TOPIC_LABELS: Record<
  Topic,
  { ko: string; emoji: string; question: string; featured?: boolean }
> = {
  today: {
    ko: '오늘의 운세',
    emoji: '☀️',
    question: '오늘 하루의 흐름이 궁금해요',
    featured: true,
  },
  love: { ko: '연애', emoji: '💕', question: '연애운이 궁금해요' },
  friendship: { ko: '우정', emoji: '🤝', question: '친구와의 관계운이 궁금해요' },
  business: { ko: '사업', emoji: '📈', question: '사업/일의 흐름이 궁금해요' },
  study: { ko: '학업·시험', emoji: '📚', question: '공부와 시험운이 궁금해요' },
  marriage: { ko: '결혼', emoji: '💍', question: '결혼운이 궁금해요' },
  luck: { ko: '행운', emoji: '🍀', question: '전반적인 운세가 궁금해요' },
  money: { ko: '금전', emoji: '💰', question: '금전운이 궁금해요' },
  health: { ko: '건강', emoji: '🌿', question: '건강운이 궁금해요' },
};

/** 모드 — 나 혼자 / 커플 / 우정 (코드 내부 식별자는 solo/couple/friends 유지) */
export const MODES = ['solo', 'couple', 'friends'] as const;
export type Mode = (typeof MODES)[number];

export const MODE_LABELS: Record<Mode, { ko: string; minSeats: number; maxSeats: number }> = {
  solo: { ko: '나 혼자', minSeats: 1, maxSeats: 1 },
  couple: { ko: '커플', minSeats: 2, maxSeats: 2 },
  friends: { ko: '우정', minSeats: 2, maxSeats: 4 },
};
